import React from 'react'
import '../style/global.scss'

const Layout = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="layout">
            {children}
        </div>
    )
}

export default Layout;